/**
 * Forgot Password Action — Phase 7 (ADR 0003).
 *
 * Server-side validation now uses `forgotPasswordSchema` so the
 * forgot-password form and the action validate against one rule.
 */

import type { ActionFunctionArgs } from 'react-router-dom';
import { forgotPasswordRequest } from '@/services/keycloakAuthService';
import { forgotPasswordSchema } from '@/modules/auth/schemas';
import { getFormDataObject, actionError, actionSuccess, transformApiError } from './helpers';

export async function forgotPasswordAction({ request }: ActionFunctionArgs) {
  try {
    const data = await getFormDataObject(request);

    const parsed = forgotPasswordSchema.safeParse({ email: data.email });
    if (!parsed.success) {
      const flat = parsed.error.flatten().fieldErrors;
      const errors: Record<string, string> = {};
      Object.entries(flat).forEach(([key, msgs]) => {
        if (msgs && msgs.length > 0 && msgs[0]) errors[key] = msgs[0];
      });
      return actionError(errors, 400);
    }

    const { email } = parsed.data;

    await forgotPasswordRequest(email);

    return actionSuccess({ submitted: true, email }, 'Password reset link sent to your email');
  } catch (error) {
    console.error('Forgot password action error:', error);

    const errorResponse = transformApiError(error);
    return actionError(errorResponse.error ?? 'Failed to send reset email', 400);
  }
}
